import { Component, inject, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  iaIconCalendarDaysAlt,
  iaIconCar,
  iaIconCircleInformation,
  iaIconCircleInformation2,
  iaIconElectricBike,
  iaIconElectricCar,
  iaIconInformationWhite,
  iaIconNewCar,
  iaIconPaintRoller,
  iaIconPhoneSignal,
  iaIconShoppingBag,
  iaIconXmark,
} from '@bcef/ia-icons';
import { IconsRegistry } from '@bcef/ia-ng-icons';
import { ContextService, getClassNames } from '@bcef/ia-shared';
import { DataLayer } from '@difa/ia-data-layer';
import { TranslateService } from '@ngx-translate/core';
import classNames from 'classnames';

@Component({
  selector: 'ia-simulateur-ppi-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  imports: [RouterOutlet],
  standalone: true,
})
export class AppComponent {
  protected typologies: string;

  private readonly translate = inject(TranslateService);

  private readonly contextService = inject(ContextService);

  private readonly iconsRegistry = inject(IconsRegistry);

  private readonly _datalayer = inject(DataLayer);

  constructor() {
    this.translate.use(this.contextService.language);
    this.typologies = classNames(getClassNames(this.contextService.typology));
    this.iconsRegistry.registerIcons([
      iaIconCircleInformation2,
      iaIconCircleInformation,
      iaIconPhoneSignal,
      iaIconCalendarDaysAlt,
      iaIconShoppingBag,
      iaIconCar,
      iaIconElectricBike,
      iaIconElectricCar,
      iaIconPaintRoller,
      iaIconNewCar,
      iaIconXmark,
      iaIconInformationWhite,
    ]);
  }
}
